import { useEffect } from "react";

/**
 * Per-route SEO: document title, meta description, canonical link,
 * and Open Graph / Twitter card tags for a single-page app that ships
 * one static index.html.
 */
const DOMAIN = "https://meridianbedbug.ca";
const DEFAULT_IMAGE =
  "https://media.base44.com/images/public/6a80a7f0e10008ea488688fc/3950e2307_generated_3a7f9f16.png";
const DEFAULT_TITLE = "Bed Bug Control & Treatment in Vancouver & the Lower Mainland | Meridian";
const DEFAULT_DESC =
  "Specialist bed bug treatment for homes, condos, hotels and short-term rentals across Vancouver and the Lower Mainland. Discreet, effective, same-week booking.";

function upsertMeta(keyAttr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${keyAttr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(keyAttr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.rel = "canonical";
    document.head.appendChild(el);
  }
  el.href = href;
}

function upsertHreflang(href) {
  // Single-language Canadian-English site: each page declares its own
  // language variant plus an x-default fallback, both pointing at the
  // page's canonical URL (reciprocal self-referencing hreflang).
  const langs = ["en-ca", "x-default"];
  langs.forEach((lang) => {
    let el = document.head.querySelector(`link[rel="alternate"][hreflang="${lang}"]`);
    if (!el) {
      el = document.createElement("link");
      el.rel = "alternate";
      el.hreflang = lang;
      document.head.appendChild(el);
    }
    el.href = href;
  });
}

export function useSeo({ title, description, path, image, type = "website", robots = "index, follow" } = {}) {
  useEffect(() => {
    const t = title || DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    const url = DOMAIN + (path || "/");

    document.title = t;
    upsertMeta("name", "description", desc);
    upsertMeta("name", "robots", robots);
    upsertCanonical(url);
    upsertHreflang(url);
    upsertMeta("property", "og:title", t);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:image", image || DEFAULT_IMAGE);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", t);
    upsertMeta("name", "twitter:description", desc);
    upsertMeta("name", "twitter:image", image || DEFAULT_IMAGE);
  }, [title, description, path, image, type, robots]);
}